import { Button, Card, Col, Row } from "react-bootstrap";

function WaiverPage() {
  return (
    <div>
      <div className="content mt-5">
        <div className="container">
          <Card className="p-5">
            <Row className="mb-4">
              <Col>
                <h1 className="m-0 form-header">
                  Veertien dagen bedenktijd private lease
                </h1>
              </Col>
            </Row>
            <p>
            <h5><b>
                Binnen 14 dagen kosteloos annuleren van uw private
                leaseovereenkomst
              </b></h5>
              <div>
                Voor ieder private leasecontract dat u ondertekent, heeft u 14
                dagen bedenktijd. Dat betekent dat u na ondertekening van het
                contract nog van de private lease kunt afzien, zolang u dat
                binnen 14 dagen nadat u het private leasecontract heeft
                ondertekend, aangeeft. In dat geval ontbindt u het leasecontract
                en dat is altijd zonder kosten voor u.
              </div>
            </p>
            <br />
            <p>
            <h5><b>Herroepingsrecht</b></h5>
              <div>
                Bij ontbinden van het contract binnen 14 dagen na ondertekening,
                maakt u als consument gebruik van uw herroepingsrecht. In uw
                contractpakket vindt u een herroepingsformulier dat u kunt
                invullen als u hiervan gebruik wilt maken. Vervolgens stuurt u
                dit ingevuld binnen 14 dagen na ondertekening,
                naar privatelease@santander.nl. Wij zullen dan uw private
                leaseovereenkomst met ons ontbinden. Als de bedenktijd van 14
                dagen verstreken is, kunt u niet meer kosteloos uw contract
                ontbinden.
              </div>
            </p>
            <br />
            <p>
            <h5><b>Wat betekent deze bedenktijd voor mij?</b></h5>
              <div>
                Omdat u recht heeft op 14 dagen bedenktijd na het ondertekenen
                van uw private leasecontract, kunt u uw leaseauto pas ophalen
                als deze bedenktijd is verstreken. Als uw leaseauto al
                beschikbaar is, snappen we dat dit niet altijd handig uitkomt.
                Maar u kunt er in zo’n geval ook voor kiezen om afstand te doen
                van uw bedenktijd.
              </div>{" "}
            </p>
            <br />
            <p>
              <h5>
              <b>  Hoe kan ik afzien van de 14 dagen bedenktijd bij private lease?
              </b></h5>
              <div>
                U kunt aangeven dat u geen 14 dagen bedenktijd voor uw private
                leasecontract nodig heeft door de ‘afstandsverklaring 14 dagen
                bedenktijd’ in te vullen en digitaal te ondertekenen. U vindt
                deze afstandsverklaring hier op onze website [link to form]. De
                door u ondertekende afstandsverklaring wordt dan toegevoegd aan
                uw private leasecontract en een afspraak voor aflevering wordt
                gemaakt. Zo kunt u snel op weg in uw nieuwe gewenste leaseauto!
              </div>
            </p>
          </Card>
          <Card>
            <Row style={{ paddingLeft: 8, paddingRight: 8 }}>
              <Col
                sm={8}
                className="p-5"
                style={{
                  background: "#CC0000",
                  color: "white",
                  borderTopLeftRadius: 5,
                  borderBottomLeftRadius: 5,
                }}
              >
                <div>
                  <p><b>
                    
                      
                    
                    <h1 className="m-0 form-header">
                    Wil je geen 14 dagen bedenktijd voor het bestellen van je
                    auto?{" "}
                </h1>
                  </b></p>
                  <div>
                    We begrijpen dat je niet altijd behoefte hebt aan 14 dagen
                  bedenktijd. Als jouw leaseauto beschikbaar is, dan kun je er
                  daarom ook voor kiezen om af te zien van de 14 dagen
                  bedenktijd en zo het bestelproces versnellen.
                  </div>
                  <br/>
                  
                  <div>
                    
                    <button className="waiver-btn">
                      <span className="mr-3">Ik wil geen 14 dagen bedenktijd</span>
                      <i className="fas fa-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </Col>
              <Col className="waiver-backgroud-img" style={{ background: "#CC0000" ,borderTopRightRadius: 5,
                    borderBottomRightRadius: 5}}>
                
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default WaiverPage;
